import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Grid, Paper, Button, Chip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useTranslation } from 'react-i18next';
import FyraSuiteImage from '../assets/fyra_suite.jpg';
import FyraApiImage from '../assets/fyra_suite_physical_ai.webp';
import { GoldenRatioImage } from '../styles/commonStyles';

interface Service {
  key: 'sec1' | 'sec2' | 'sec3';
  image?: string;
  to: string;
}

const services: Service[] = [
  { key: 'sec1', image: FyraSuiteImage, to: '/fyrasuite' },
  { key: 'sec2', image: FyraApiImage, to: '/fyraapi' },
  { key: 'sec3', to: '/contact-form' },
];

/** ターゲット業界ごとに課題とソリューションを並べた事業内容セクション */
const ServiceSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box mt={4} mb={6}>
      <Typography
        variant="h3"
        align="center"
        sx={{ fontSize: { xs: '7vw', sm: 32 } }}
        gutterBottom
      >
        {t('nav.service')}
      </Typography>

      {services.map((service, index) => {
        const isImageLeft = index % 2 === 1;
        const hasImage = Boolean(service.image);
        return (
          <Grid container spacing={4} mt={0} mb={4} key={service.key}>
            <Grid
              item
              xs={12}
              md={hasImage ? 6 : 12}
              sx={{ order: { xs: 0, md: isImageLeft ? 1 : 0 } }}
            >
              <Chip
                label={t(`service.${service.key}.target`)}
                color="secondary"
                sx={{ fontWeight: 700, mb: 1.5 }}
              />
              <Typography variant="h4" gutterBottom>
                {t(`service.${service.key}.product`)}
              </Typography>
              <Typography
                variant="subtitle1"
                component="div"
                sx={{ fontWeight: 600, color: 'primary.main', mb: 2 }}
              >
                {t(`service.${service.key}.tagline`)}
              </Typography>
              <Typography
                variant="overline"
                component="div"
                sx={{ fontWeight: 700, lineHeight: 1.5 }}
              >
                {t('service.labels.issue')}
              </Typography>
              <Typography paragraph>
                {t(`service.${service.key}.issue`)}
              </Typography>
              <Typography
                variant="overline"
                component="div"
                sx={{ fontWeight: 700, lineHeight: 1.5 }}
              >
                {t('service.labels.solution')}
              </Typography>
              <Typography paragraph>
                {t(`service.${service.key}.solution`)}
              </Typography>
              <Button
                component={RouterLink}
                to={service.to}
                variant="contained"
                color="primary"
                size="medium"
                endIcon={<ArrowForwardIcon />}
                sx={{ fontWeight: 700, textTransform: 'none' }}
              >
                {t(`service.${service.key}.btn`)}
              </Button>
            </Grid>
            {hasImage && (
              <Grid
                item
                xs={12}
                md={6}
                sx={{ order: { xs: 1, md: isImageLeft ? 0 : 1 } }}
              >
                <Paper elevation={0}>
                  <GoldenRatioImage
                    src={service.image}
                    alt={t(`service.${service.key}.product`)}
                  />
                </Paper>
              </Grid>
            )}
          </Grid>
        );
      })}
    </Box>
  );
};

export default ServiceSection;
